/**
 * this script must be included when survey is enabled.
 */

window.IAS = window.IAS || {};
IAS.props = IAS.props || [];

IAS.visitor = IAS.visitor || {}; //initialisierung von visitor
IAS.visitor.data = IAS.visitor.data || {}; //initialisierung von data

IAS.props.push({
    'type': 'LAYER',
    'container': 'layer_container',
    'zone': 'diyedit_'+ (jimdoData.surveyData.countryCode=='de'?'':(jimdoData.surveyData.countryCode+'_'))+'layer',
    'refId': jimdoData.surveyData.contractIdHash,
    'context': '',
    'usessId': jimdoData.surveyData.usessionId,
});

IAS.visitor.usessId = jimdoData.surveyData.usessionId;

IAS.visitor.data.featureClass = 'DIY';
IAS.visitor.data.provisioningId = jimdoData.surveyData.provisioningId;
IAS.visitor.data.featureCreationDate = jimdoData.surveyData.createDate;
IAS.visitor.data.featureContext = jimdoData.surveyData.biTrackingContractTypeIdentifier;

(function(){
    window.OAO = window.OAO || {};
    window.OAO.q = window.OAO.q || {};
    window.OAO.q.c = window.OAO.q.c || [];
    window.OAO.q.c.push(['setMarket', jimdoData.surveyData.countryCode.toUpperCase()]);
    window.OAO.q.c.push(['setLanguage', jimdoData.surveyData.language]);

    var a = document.createElement("script");
    a.type = "text/javascript";
    a.async = true;
    a.id = "oaotag"
    a.src = jimdoData.surveyData.url;
    var b = document.getElementsByTagName("script")[0];
    b.parentNode.insertBefore(a, b);
}());


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/js/survey/surveyScriptLoader.js
 ** module id = 928
 ** module chunks = 0
 **/